import * as UI from "@iyk/ui"

export const Card = ({ className, children }: Card.Props) => {
  return <div className={UI.cx(classForCard, className)}>{children}</div>
}
export const classForCard = UI.cx("rounded bshadow bshadow-grayA-4 bg-grayA-2")

export namespace Card {
  export type Props = {
    children: React.ReactNode
    className?: string
  }
}
